// extracted by mini-css-extract-plugin
export var csatScore = "_my-5";
export var header = "_my-1";
export var panelWrapper = "_my-2";
export var postPreview = "_my-3";
export var rightContent = "_my-0";
export var wrappingText = "_my-4";